<template>
  <div
    @click.stop="closePopup"
    :class="{
      'lightbox-popup': true,
      'mobile': isMobileView
    }">

    <div class="light-box-center">
      <div :class="{'container': true, 'h-100': center}">

        <div :class="{'row': true, 'h-100': center}">
          <div
            @click.stop
            class="col">

            <slot name="light-box-content" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  methods: {
    closePopup () {
      this.$emit('close', { close: true })
    }
  },

  computed: {
    isMobileView () {
      return this.$store.getters.isMobileView
    }
  },

  props: {
    center: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  directives: {
    ClickOutside
  }
}
</script>

<style scoped>
.lightbox-popup {
  position: fixed;
  z-index: 1000;
  background-color: rgba(53, 54, 53, 0.88);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 53px;
  box-sizing: border-box;
  overflow-y: scroll;
}
.lightbox-popup::-webkit-scrollbar {
  display: none;
}
.lightbox-popup.mobile {
  padding-top: 53px;
}

.light-box-center {
  height: 100%;
  width: 100%;
}
.light-box-center .row {
  align-items: center;
  justify-content: center;
}

.popup-content {
  margin-bottom: 53px;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/display/Lightbox.vue?1fd06723